<template>
  <div style="position: relative">
      <el-tiptap
        v-model="content"
        :extensions="extensions"
        :editor-props="editorProps"
        lang="zh"
        placeholder="请输入内容 …"
        ref="editor"
        :key="editorKey"
        @addCreated="addCreated"
        @openAi="openAi"
        @onUpdate="onEditorUpdate"
        @selection-update="onSelectionUpdate"
      />

    <div class="right-toolbar">
      <!-- 替换 -->
      <el-tooltip class="item" effect="dark" content="文内搜索和替换" placement="bottom">
        <i class="el-icon-search" @click="handleOpenSearch"></i>
      </el-tooltip>

      <!-- 分享 -->
      <el-tooltip trigger="hover" popper-class="menu-tooltip" effect="dark">
        <ul slot="content" class="menu-list">
          <li @click="toShare(0)">好友分享</li>
          <li @click="toShare(1)">站外分享</li>
          <li @click="uploadToWechat">转存小程序</li>
        </ul>
        <i class="el-icon-share"></i>
      </el-tooltip>

      <!-- 上传 -->
      <el-tooltip class="item" effect="dark" content="支持doc,pdf,epub" placement="bottom">
        <i class="el-icon-upload2" @click="uploadDoc" />
      </el-tooltip>

      <!-- 下载 -->
      <!-- <el-tooltip trigger="hover" popper-class="menu-tooltip" effect="dark">
        <ul slot="content" class="menu-list">
          <li v-if="note && note.talk_mp3" @click="downloadConfirm">下载MP3</li>
        </ul>
        <i class="el-icon-download" />
      </el-tooltip> -->

      <!-- 生成功能下拉菜单 -->
      <el-tooltip trigger="hover" popper-class="menu-tooltip" effect="dark">
        <ul slot="content" class="menu-list">
          <li @click="showMindMapDialog">生成脑图</li>
          <li @click="showTimelineDialog">生成时间轴</li>
        </ul>
        <i class="el-icon-magic-stick"></i>
      </el-tooltip>
      
      <!-- 实体关系分析 -->
      <el-tooltip class="item" effect="dark" content="实体关系分析" placement="bottom">
        <i class="el-icon-share" @click="analyzeEntities" style="transform: rotate(180deg);"></i>
      </el-tooltip>
      
      <!-- 分类元素分析 -->
      <el-tooltip class="item" effect="dark" content="分类元素分析" placement="bottom">
        <i class="el-icon-s-grid" @click="analyzeCategoryElements"></i>
      </el-tooltip>
      
      <!-- 词条 -->
      <el-tooltip class="item" effect="dark" content="词条管理" placement="bottom">
        <i class="el-icon-collection-tag" @click="goToKeywords"></i>
      </el-tooltip>
      
      <!-- 保存 -->
      <el-tooltip trigger="hover" popper-class="menu-tooltip" effect="dark">
        <ul slot="content" class="menu-list">
          <li @click="sendSave">直接保存</li>
          <li @click="saveAs">另存为</li>
          <li @click="downloadNote">下载DOC</li>
        </ul>
        <img src="@/assets/editor/save.png" />
      </el-tooltip>
      
      <!-- <el-tooltip class="item" effect="dark" content="全部展开" placement="bottom">
        <i class="el-icon-folder-opened" @click="expandAll" />
      </el-tooltip>

      <el-tooltip class="item" effect="dark" content="全部折叠" placement="bottom">
        <i class="el-icon-folder" @click="collapseAll" />
      </el-tooltip> -->
    </div>

    <input type="file" ref="docFile" accept=".doc,.docx,.pdf,.epub" id="file" @change="handleFileChange" style="display: none;">
    <el-dialog :visible.sync="dialogVisible" class="title-box">
      <el-form label-position="left" label-width="80px">
        <div v-if="saveType === 1">白板保存</div>
        <el-form-item label="标题" v-if="saveType === 1">
          <el-input v-model="broadTitle" placeholder="请输入标题" />
        </el-form-item>
        <el-form-item label="标题" v-if="saveType === 2">
          <el-input v-model="saveAsTitle" placeholder="请输入标题" />
        </el-form-item>
        <el-form-item label="标题" v-if="saveType === 0">
          <el-input v-model="title" placeholder="请输入标题" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveWithTitle">确认</el-button>
      </span>
    </el-dialog>

    <!-- 脑图生成确认对话框 -->
    <el-dialog
      title="生成脑图"
      :visible.sync="mindMapDialogVisible"
      width="400px">
      <div>
        <p>系统将根据文档中的标题层级（H1-H6）自动生成脑图结构。</p>
        <p>请确保文档中包含合适的标题标签。</p>
        <p style="color: #E6A23C;">注意：生成的脑图将使用当前文档的标题。</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="mindMapDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="generateMindMap">确认生成</el-button>
      </span>
    </el-dialog>

    <!-- 时间轴生成确认对话框 -->
    <el-dialog
      title="生成时间轴"
      :visible.sync="timelineDialogVisible"
      width="400px">
      <div>
        <p>系统将根据文档内容自动生成时间轴文件。</p>
        <p>请确保文档中包含时间相关的内容。</p>
        <p style="color: #E6A23C;">注意：生成的时间轴将使用当前文档的标题和内容。</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="timelineDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="generateTimeline">确认生成</el-button>
      </span>
    </el-dialog>

    <!-- 分类元素分析确认对话框 -->
    <el-dialog
      title="分类元素分析"
      :visible.sync="categoryAnalysisDialogVisible"
      width="350px">
      <div>
        <p>系统将分析文档中的标题和【】元素，生成分类白板。</p>
        <p style="color: #67C23A; font-size: 13px;">✓ 自动识别标题和元素，每个分类自动组合为整体</p>
        <p style="color: #E6A23C; font-size: 13px;">注意：分析结果将在白板页面中展示，每个分类可作为整体移动。</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="categoryAnalysisDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="performCategoryAnalysis">确认分析</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="实体关系分析"
      :visible.sync="entityAnalysisDialogVisible"
      width="400px">
      <div>
        <p>系统将根据文档内容自动分析实体、关系和事件。</p>
        <p>分析结果将在白板页面中以图形化方式展示。</p>
        <p style="color: #E6A23C;">注意：分析过程需要1-2分钟，请耐心等待。</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="entityAnalysisDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="performEntityAnalysis">确认分析</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="addVisible">
      <div class="dialog-content">
        <el-form label-position="left" label-width="80px" v-for="(item, idx) in createData.list" :key="idx">
          <el-form-item label="词条名称" v-show="!item.hide">
            <el-input v-model="item.title" placeholder="请输入词条名称标题" />
            <el-select v-model="item.type" placeholder="请选择图形">
              <el-option :key="2" label="白板方形" :value="2">
              </el-option>
              <el-option :key="1" label="白板圆形" :value="1">
              </el-option>
            </el-select>
            <i class="el-icon-delete" @click="deleteItem(idx)"></i>
          </el-form-item>
          <el-form-item label="词条内容" v-show="!item.hide">
            <p class="add-content">{{ item.content }}</p>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addVisible = false">取消</el-button>
        <el-button type="primary" @click="addEntry">确认</el-button>
      </span>
    </el-dialog>
    <el-dialog 
      title="分享文章" 
      :visible.sync="shareDialog" 
      width="600px" 
      :before-close="handleShareClose"
      class="share-dialog">
      <div class="share-content">
        <div class="share-tip" v-if="friendList.length">
          <i class="el-icon-info"></i>
          <span>选择要分享给的好友</span>
        </div>
        <div class="no-friends" v-if="!friendList.length">
          <i class="el-icon-user"></i>
          <p>暂无好友</p>
          <p class="tip">请先添加好友后再进行分享</p>
        </div>
        <div class="friend-list" v-if="friendList.length">
          <el-checkbox-group v-model="checkList">
            <div class="item-friend" v-for="item in friendList" :key="item.bei_member_id">
              <div class="left">
                <el-checkbox :label="item.bei_member_id"></el-checkbox>
              </div>
              <div class="right">
                <img :src="item.member_avatar" />
                <span class="nick">{{ item.member_name }}</span>
              </div>
            </div>
          </el-checkbox-group>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="shareDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitShare" :disabled="!checkList.length">确 定</el-button>
      </span>
    </el-dialog>
    <p id="copyBtn" ref="copyBtn" style="display: none" :data-clipboard-text="copyText"></p>
    
    <!-- 搜索面板 -->
    <SearchPanel 
      v-if="searchPanelVisible"
      :visible.sync="searchPanelVisible" 
      :editor="editorInstance || ($refs.editor && $refs.editor.editor)"
    />
    
    <!-- LaTeX 预览悬浮框 -->
    <LatexPreview ref="latexPreview" />
  </div>
</template>

<script>
import request from '@/http/request'
import axios from '@/http'
import requestFromData from '@/http/requestFromData'
import { EventBus } from '@/main.js'
import ClipboardJS from 'clipboard'
import { 
  downloadAsWord, 
  saveDocument, 
  updateDocument, 
  saveDocumentAs,
  saveToDraft,
  validateContent as validateDocContent,
  validateTitle
} from '@/utils/documentSaveDownload'
import {
  Blockquote,
  Bold,
  BulletList,
  Doc,
  History,
  Image,
  Italic,
  Link,
  ListItem,
  OrderedList,
  Paragraph,
  Strike,
  Text,
  TextAlign,
  TextColor,
  TextHighlight,
  TrailingNode,
  Underline
} from 'element-tiptap'
import 'element-tiptap/lib/index.css'
import 'katex/dist/katex.min.css'
import { analyzeEntitiesAndRelationships } from '@/utils/entityAnalysis'
import { analyzeCategoryAndElements, validateContent, convertToDraftData } from '@/utils/categoryAnalysis'
import Ai from './ai/index.js'
import Create from './create/index.js'
import EnglishParse from './english-parse/index.js'
import Help from './help/index.js'
import LaTeX from './latex/index.js'
import SearchPanel from './search/SearchPanel.vue'
import LatexPreview from './latex/LatexPreview.vue'
import CollapsibleHeading from './collapsible-heading.js'
import './collapsible.scss'

const sizeLimit = 4 * 1024 * 1024

// 将 extensions 移出 data，避免 Vue 的响应式系统干扰 Tiptap
// 按照用户要求的bubble工具栏顺序配置
const extensions = [
  new Doc(),
  new Text(),
  new Paragraph(),
  new History(),
  new TrailingNode(),
  new CollapsibleHeading({ level: 6, collapsible: true }),
  // 按照要求的bubble工具栏顺序：B-粗体、U-下划线、I-斜体、S-删除线、无序列表、有序列表、左对齐、居中对齐、右对齐、两端对齐、文本高亮、文本颜色、添加词条、AI助手、英法句子分析
  new Bold({ bubble: true }),
  new Underline({ bubble: true, menubar: false }),
  new Italic({ bubble: true }),
  new Strike({ bubble: true }),
  new ListItem(),
  new BulletList({ bubble: true }),
  new OrderedList({ bubble: true }),
  new TextAlign({
    alignments: ['left', 'center', 'right', 'justify'],
    bubble: true
  }),
  new TextHighlight({ bubble: true, menubar: true }),
  new TextColor({ bubble: true, menubar: true }),
  new Create({ bubble: true, menubar: false }),
  new Ai({ bubble: true, menubar: false }),
  new EnglishParse({ bubble: true, menubar: false }),
  new LaTeX({ bubble: true, menubar: true }),
  new Help({ bubble: false, menubar: false }),
  new Link(),
  new Image({
    uploadRequest: async (file) => {
      if (!file) {
        throw new Error('无效的文件对象')
      }
      let actualFile = file
      if (file.raw && file.raw instanceof File) {
        actualFile = file.raw
      } else if (file.originFileObj && file.originFileObj instanceof File) {
        actualFile = file.originFileObj
      } else if (file.file && file.file instanceof File) {
        actualFile = file.file
      }
      if (!actualFile || !(actualFile instanceof File || actualFile instanceof Blob)) {
        throw new Error('获取的文件对象无效')
      }
      try {
        const authorization = localStorage.getItem('authorization')
        if (!authorization) {
          throw new Error('未找到认证token')
        }
        const formData = new FormData()
        formData.append('file', actualFile)
        formData.append('upload_type', 'image')
        const response = await axios.post('/api/upload/index', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            authorization: authorization
          }
        })
        
        let imageUrl = null
        // 优先使用完整的OSS URL
        if (response && response.result && response.result.complete_url) {
          imageUrl = response.result.complete_url
        } else if (response && response.result && response.result.short_url) {
          imageUrl = response.result.short_url
          // 如果是相对路径，转换为完整URL
          if (imageUrl.startsWith('/')) {
            imageUrl = window.location.origin + imageUrl
          }
        } else if (response && response.result && response.result.src) {
          imageUrl = response.result.src
        } else if (response && response.src) {
          imageUrl = response.src
        } else if (response && response.result && response.result.url) {
          imageUrl = response.result.url
        } else if (response && response.url) {
          imageUrl = response.url
        }
        
        if (imageUrl) {
          return imageUrl
        }
        throw new Error('上传失败或无效的响应')
      } catch (error) {
        console.error('上传错误:', error)
        throw error
      }
    }
  }),
  new Blockquote(),
]

export default {
  components: {
    SearchPanel,
    LatexPreview
  },
  data () {
    return {
      // 将 editorInstance 放到 data 中，使其成为响应式属性
      editorInstance: null,
      editorKey: 0, // 用于强制重新创建编辑器实例
      editorProps: {
        // The handleClick logic is now in the CollapsibleHeading extension.
        attributes: {
          style: 'overflow: visible; position: relative;'
        }
      },
      extensions: Object.freeze(extensions),
      value: '',
      dialogVisible: false,
      content: '',
      title: '',
      broadTitle: '',
      saveAsTitle: '',
      saveType: 0,
      addVisible: false,
      shareDialog: false,
      createData: {
        name: '',
        list: [],
        type: '',
        back: null
      },
      showAudio: false,
      checkList: [],
      copyText: '',
      friendList: [],
      userinfo: JSON.parse(localStorage.getItem('userinfo')),
      searchPanelVisible: false,
      mindMapDialogVisible: false,
      savedDraftId: null, // 保存的白板ID
      timelineDialogVisible: false,
      entityAnalysisDialogVisible: false,
      categoryAnalysisDialogVisible: false, // 分类分析对话框
    }
  },
  props: ['note','uptitle', 'upcontent', 'update'],
  watch: {
    upcontent (newVal) {
      // 不要清空title，让uptitle watch来处理标题更新
      this.$nextTick(() => {
        this.content = newVal
        
        // 尝试不重新创建编辑器，而是直接更新内容并清空历史
        if (this.editorInstance) {
          // 清空历史记录
          this.editorInstance.commands.clearContent()
          this.editorInstance.commands.setContent(newVal)
          this.editorInstance.commands.clearHistory()
        } else {
          // 如果编辑器实例不存在，才重新创建
          this.editorKey++
        }
        
        // this.renderLatexFormulas() // 禁用自动渲染
      })
    },
    uptitle (newVal) {
      this.title = newVal
      this.oldtitle = newVal
    },
    update (newVal) {
      this.isUpdate = newVal
    },
    content (newVal) {
      // 当内容变化时，延迟渲染LaTeX公式
      // 已禁用自动渲染，使用悬浮预览方案
      // this.$nextTick(() => {
      //   setTimeout(() => {
      //     this.renderLatexFormulas()
      //   }, 100)
      // })
    }
  },
  computed: {
    memberIdentity () {
      return this.$store.state.user.userInfoMore.memberIdentity
    }
  },
  methods: {
    onEditorUpdate({ editor }) {
      this.editorInstance = editor;
      // LaTeX预览现在是手动模式，可以安全启用
      this.$nextTick(() => {
        this.setupLatexPreview();
      });
    },
    
    onSelectionUpdate({ editor }) {
      // 保持选中事件处理，但移除调试信息
      const { from, to, empty } = editor.state.selection
      
      if (!empty) {
        // 如果需要，可以在这里添加选中文本的处理逻辑
        const selectedText = editor.state.doc.textBetween(from, to)
      }
    },
    goToKeywords() {
      this.$router.push('/keywords');
    },
    expandAll() {
      if(this.editorInstance) {
        this.editorInstance.commands.expandAll();
      }
    },
    collapseAll() {
      if(this.editorInstance) {
        this.editorInstance.commands.collapseAll();
      }
    },
    downloadConfirm() {
      if (this.note && this.note.talk_mp3) {
        download(this.note.talk_mp3)
        this.$message.success('下载成功')
      }
    },
    handleShareClose() {
      this.shareDialog = false
    },
    submitShare() {
      if (!this.checkList.length) {
        return this.$message.info('请选择分享人')
      }
      const paperId = this.$route.query.paperId
      if (!paperId) {
        return this.$message.error('缺少文章ID，无法分享')
      }
      
      const loading = this.$loading({
        lock: true,
        text: '分享中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      
      request('/api/Paper/paperShare', {
        paper_id: paperId,
        member_ids: this.checkList.join()
      }).then(() => {
        loading.close()
        this.$message.success('分享成功')
        this.shareDialog = false
        this.checkList = [] // 清空选择
      }).catch(err => {
        loading.close()
        console.error('分享失败:', err)
        this.$message.error('分享失败，请重试')
      })
    },
    uploadToWechat() {
      const strippedContent = this.content.replace(/(<([^>]+)>)/gi, '')
      if (!strippedContent.trim()) {
        this.$message.error('内容不能为空')
        return
      }
      if (!this.title) {
        this.$message.error('标题不能为空')
        return
      }
      
      const loading = this.$loading({
        lock: true,
        text: '上传中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      
      request('/api/wechatarticle/AddArticle', {
        title: this.title,
        content: this.content,
        
      }).then(() => {
        loading.close()
        this.$message.success('上传到微信文章成功')
      }).catch((error) => {
        loading.close()
                 this.$message.error('上传失败: ' + (error.message || '未知错误'))
       })
     },
    toShare (command) {
      if (command) {
        const paperId = this.$route.query.paperId
        if (!paperId) {
          this.$message.error('缺少文章ID，无法生成分享链接')
          return
        }
        this.copyText = window.location.origin + `/#/editor/note?paperId=${paperId}`
        
        // 先设置复制文本，然后触发复制
        this.$nextTick(() => {
          try {
            const clipboard = new ClipboardJS('#copyBtn')
            clipboard.on('success', (e) => {
              this.$message.success('链接已复制到剪切板')
              e.clearSelection()
              clipboard.destroy()
            })
            clipboard.on('error', (e) => {
              console.error('ClipboardJS复制失败:', e)
              // 尝试使用原生API复制
              this.fallbackCopy()
              clipboard.destroy()
            })
            
            // 触发点击事件来执行复制
            this.$refs.copyBtn.click()
          } catch (error) {
            console.error('ClipboardJS初始化失败:', error)
            // 使用备用复制方案
            this.fallbackCopy()
          }
        })
      } else {
        // 检查用户是否登录
        if (!this.userinfo) {
          this.$message.error('请先登录')
          return
        }
        
        this.shareDialog = true
        request('/mobile/member/myFans', {
          key: this.userinfo?.key,
          type: '0'
        }).then(res => {
          this.friendList = res || []
          if (!this.friendList.length) {
            this.$message.info('暂无好友，请先添加好友')
          }
        }).catch(err => {
          console.error('获取好友列表失败:', err)
          this.$message.error('获取好友列表失败，请重试')
          this.shareDialog = false
        })
      }
    },
    fallbackCopy() {
      // 使用现代浏览器的 Clipboard API
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(this.copyText).then(() => {
          this.$message.success('链接已复制到剪切板')
        }).catch(err => {
          console.error('Clipboard API复制失败:', err)
          this.showCopyDialog()
        })
      } else {
        // 备用方案：显示链接让用户手动复制
        this.showCopyDialog()
      }
    },
    showCopyDialog() {
      this.$alert(this.copyText, '请手动复制链接', {
        confirmButtonText: '确定',
        type: 'info',
        customClass: 'copy-link-dialog'
      })
    },
    deleteItem (idx) {
      this.createData.list[idx].hide = true
    },
    addEntry () {
      const list = this.createData.list.filter(item => !item.hide)
      if (list.length === 0) {
        return this.$message.error('词条不能为空')
      }
      const back = this.createData.back
      list.forEach(item => {
        item.mk_type = item.type === 1 ? 'cir' : 'rect'
      })
      request('api/Keywords/addBatchMemberKeywords', {
        paper_id: this.$route.query.paperId,
        keywords_data: JSON.stringify(list)
      }).then(res => {
        this.$message.success('创建成功')
        if (back) {
          back()
        }
        this.addVisible = false
      })
    },
    async uploadDoc () {
      this.$refs.docFile.dispatchEvent(new MouseEvent('click'))
    },
    handleFileChange () {
      const loading = this.$loading({
        lock: true,
        text: '文件上传中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const fileInput = this.$refs.docFile
      const file = fileInput.files[0]

      if (file.size > sizeLimit) {
        fileInput.value = ''
        this.$message.error('文件大小超过限制')
        loading.close()
        return
      }
      const userInfo = JSON.parse(localStorage.getItem('userinfo'))
      const formData = new FormData()
      formData.append('file', file)
      formData.append('member_id', userInfo.userid)
      // 使用XMLHttpRequest或Fetch API发送数据
      var xhr = new XMLHttpRequest()
      xhr.open('POST', '/api/Paper/getPaperByWord', true)
      xhr.onload = () => {
        if (xhr.status === 200) {
          const result = JSON.parse(xhr.responseText).result
          
          // 使用 DOMParser 来安全地解析 HTML
          const parser = new DOMParser()
          const doc = parser.parseFromString(result.paper_url, 'text/html')

          // 移除所有图片标签
          const images = doc.getElementsByTagName('img')
          while(images.length > 0) {
            images[0].parentNode.removeChild(images[0])
          }
          // 获取处理后的 HTML
          const content = doc.body.innerHTML
          // 追加到现有内容
          this.content = this.content + content
          this.$message.success('文件导入成功')
          loading.close()
        } else {
          loading.close()
          this.$message.error('文件上传失败')
        }
        fileInput.value = ''
      }
      xhr.send(formData)
    },
    addCreated (obj) {
      this.addVisible = true
      this.createData = obj
    },
    saveAs () {
      this.saveType = 2
      this.saveAsTitle = this.title
      this.dialogVisible = true
    },
    sendSave () {
      this.saveType = 0
      const strippedContent = this.content.replace(/(<([^>]+)>)/gi, '')
      if (!strippedContent.trim()) {
        this.$message.error('保存时内容不能为空')
      } else {
        if (this.title) {
          this.saveWithTitle()
        } else {
          this.saveType = 0
          this.dialogVisible = true
        }
      }
    },
    async saveWithTitle () {
      // 另存为
      if (this.saveType === 2) {
        if (!this.saveAsTitle) {
          return this.$message.error('标题不能为空')
        }
        try {
          await saveDocumentAs(this.saveAsTitle, this.content, this.$router)
          this.$message.success('另存为成功')
          this.title = this.saveAsTitle // 更新当前标题
          this.dialogVisible = false
        } catch (error) {
          this.$message.error(error.message || '另存为失败')
        }
        return
      }
      
      // 保存为白板
      if (this.saveType === 1) {
        if (!this.broadTitle) {
          return this.$message.error('标题不能为空')
        }
        const paperId = this.$route.query.paperId
        try {
          await saveToDraft(this.broadTitle, this.content, paperId)
          this.$message.success('保存白板成功')
          this.broadTitle = ''
          this.dialogVisible = false
        } catch (error) {
          this.$message.error(error.message || '保存白板失败')
        }
        return
      }
      
      // 直接保存或新建
      if (!this.title) {
        return this.$message.error('标题不能为空')
      }
      
      const paperId = this.$route.query.paperId
      try {
        if (paperId) {
          // 更新现有文档
          await updateDocument(paperId, this.title, this.content)
          this.$message.success('编辑成功')
          this.$emit('update:title', this.title)
        } else {
          // 新建文档
          await saveDocument(this.title, this.content, this.$router)
          this.$message.success('保存成功')
        }
        this.dialogVisible = false
      } catch (error) {
        // 处理内容无变更的情况
        if (error.isNoChange || (error.code === 100 && error.message && error.message.includes('无更改'))) {
          this.$message.warning('编辑无新改动，无需重复保存')
        } else if (error.message && error.message.includes('无变更')) {
          this.$message.success('内容无变更，请变更后在进行保存')
        } else {
          this.$message.error(error.message || '保存失败')
        }
      }
    },
    handleOpenSearch() {
      // 确保编辑器实例存在的多种方式
      let editorInstance = this.editorInstance
      
      // 方式1：从当前的editorInstance获取
      if (!editorInstance && this.$refs.editor && this.$refs.editor.editor) {
        editorInstance = this.$refs.editor.editor
        this.editorInstance = editorInstance
      }
      
      // 方式2：如果还是没有，尝试从组件内部获取
      if (!editorInstance && this.$refs.editor && this.$refs.editor.$children) {
        const editorChild = this.$refs.editor.$children.find(child => child.editor)
        if (editorChild && editorChild.editor) {
          editorInstance = editorChild.editor
          this.editorInstance = editorInstance
        }
      }
      
      // 显示搜索面板
      this.searchPanelVisible = true
      
      // 如果编辑器实例仍然为空，延迟获取
      if (!editorInstance) {
        this.$nextTick(() => {
          setTimeout(() => {
            if (this.$refs.editor && this.$refs.editor.editor) {
              this.editorInstance = this.$refs.editor.editor
            }
          }, 200)
        })
      }
    },
    async downloadNote () {
      if (!this.content || !this.content.trim()) {
        this.$message.error('内容为空，无法下载')
        return
      }
      
      const loading = this.$loading({
        lock: true,
        text: '生成文档中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      
      try {
        // 使用新的下载工具，传入标题作为文件名
        const filename = this.title || '文档'
        await downloadAsWord(this.content, filename)
        loading.close()
        this.$message.success('下载成功')
      } catch (error) {
        console.error('下载失败:', error)
        loading.close()
        this.$message.error(error.message || '下载失败')
      }
    },
    openAi (text) {
      this.$parent.$parent.openAi(text, this.content)
    },
    addCreated (arr, callback) {
      this.addVisible = true
      this.createData.list = arr.map((con) => {
        const item = {
          type: null,
          name: '',
          content: con,
          hide: false
        }
        return item
      })
      this.createData.back = callback
    },
    deleteItem (idx) {
      let total = 1
      this.createData.list.forEach((item) => {
        if (item.hide) {
          total += 1
        }
      })
      if (this.createData.list.length === total) {
        return this.$message.error('至少需要一个词条内容')
      }
      this.createData.list[idx].hide = true
    },
    addEntry () {
      const list = this.createData.list
      for (let i = 0; i < list.length; i += 1) {
        const item = list[i]
        if (!item.title && !item.hide) {
          return this.$message.error('词条标题不能为空')
        }
      }
      const paperId = this.$route.query.paperId || ''

      list.forEach((item) => {
        if (!item.hide) {
          request('/api/Keywords/addMemberKeywords', {
            description: item.content,
            keywords: item.title,
            paper_id: paperId
          }).then(() => {
            this.$message.success('添加词条成功')
          })
        }
      })
      this.addVisible = false
      this.createData.back(this.createData.list)
    },
    generateMindMap() {
      if (!this.title) {
        this.$message.error('请先输入标题');
        return;
      }
      
      const loading = this.$loading({
        lock: true,
        text: '正在生成脑图...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      
      // 获取paperId作为source_id
      const paperId = this.$route.query.paperId;
      
      axios.post('/api/Mindmap/paperGenerateMindmap', {
        title: this.title,
        content: this.content,
        source_id: paperId || '',
        source: 3
      }).then(res => {
        loading.close();
        
        if (res.code === 200 && res.result && res.result.mind_map_id) {
          this.$message.success(`脑图"${this.title}"生成成功，正在打开...`);
          this.mindMapDialogVisible = false;
          setTimeout(() => {
            window.open(`#/mind/${res.result.mind_map_id}`, '_blank');
          }, 300);
        } else {
          this.$message.error(res.message || '脑图生成失败');
        }
      }).catch(error => {
        loading.close();
        this.$message.error('脑图生成失败：' + (error.message || '未知错误'));
      });
    },
    
    showMindMapDialog() {
      if (!this.title) {
        this.$message.error('请先输入标题');
        return;
      }
      
      this.mindMapDialogVisible = true;
    },
    
    generateTimeline() {
      if (!this.title) {
        this.$message.error('请先输入标题');
        return;
      }
      
      if (!this.content || !this.content.trim()) {
        this.$message.error('请先输入内容');
        return;
      }
      
      const loading = this.$loading({
        lock: true,
        text: '正在生成时间轴...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      
      // 获取paperId作为source_id
      const paperId = this.$route.query.paperId;
      
      axios.post('/api/Timeline/paperGenerateTimeline', {
        title: this.title,
        paper_content: this.content,
        source_id: paperId || '',
        source: 3
      }).then(res => {
        loading.close();
        
        if (res.code === 200) {
          this.$message.success(`时间轴"${this.title}"生成成功，正在打开...`);
          this.timelineDialogVisible = false;
          
          // 延迟一下再跳转，让用户看到成功消息
          setTimeout(() => {
            // 如果API返回了时间轴ID，则跳转到对应的时间轴页面
            if (res.result && (res.result.timeline_id || res.result.id || res.result)) {
              const timelineId = res.result.timeline_id || res.result.id || res.result;
              window.open(`#/timeline?id=${timelineId}`, '_blank');
            } else {
              // 如果没有返回ID，则跳转到时间轴列表页面
              window.open('#/timeline', '_blank');
            }
          }, 300);
        } else {
          this.$message.error(res.message || '时间轴生成失败');
        }
      }).catch(error => {
        loading.close();
        this.$message.error('时间轴生成失败：' + (error.message || '未知错误'));
      });
    },
    
    showTimelineDialog() {
      if (!this.title) {
        this.$message.error('请先输入标题');
        return;
      }
      
      if (!this.content || !this.content.trim()) {
        this.$message.error('请先输入内容');
        return;
      }
      
      this.timelineDialogVisible = true;
    },
    
    analyzeEntities() {
      if (!this.content || !this.content.trim()) {
        this.$message.error('请先输入内容');
        return;
      }
      
      // 立即启动流程并展开流程图悬浮框
      this.$store.dispatch('processFlow/startFlow')
      
      // 直接执行分析，不显示确认对话框
      this.performEntityAnalysis();
    },
    
    analyzeCategoryElements() {
      if (!this.content || !this.content.trim()) {
        this.$message.error('请先输入内容');
        return;
      }
      
      // 先验证内容格式
      const validation = validateContent(this.content);
      if (!validation.isValid) {
        this.$message.error(validation.message);
        return;
      }
      
      this.categoryAnalysisDialogVisible = true;
    },
    
    async performCategoryAnalysis() {
      this.categoryAnalysisDialogVisible = false;
      
      const loading = this.$loading({
        lock: true,
        text: '正在分析分类元素...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      
      try {
        // 执行分析
        const analysisResult = analyzeCategoryAndElements(this.content);
        
        if (!analysisResult.isValid) {
          throw new Error('分析结果无效：' + (analysisResult.error || '未知错误'));
        }
        
        // 转换为白板数据格式
        const draftData = convertToDraftData(analysisResult);
        
        if (!draftData) {
          throw new Error('转换白板数据失败');
        }
        
        // 调用保存白板的接口
        await this.saveCategoryAnalysisToBoard(draftData);
        
        loading.close();
        
        this.$message.success(`分类分析完成！识别到 ${analysisResult.categories.length} 个分类，共 ${analysisResult.totalElements} 个元素，正在跳转到白板页面...`);
        
        // 延迟跳转到白板页面
        setTimeout(() => {
          // 跳转到草稿/白板页面，带上已保存的白板ID
          this.$router.push({
            name: 'draft',
            query: {
              id: this.savedDraftId || '',
              type: 'category-analysis',
              source: 'note'
            }
          });
        }, 1000);
        
      } catch (error) {
        loading.close();
        console.error('分类分析失败:', error);
        this.$message.error('分类分析失败：' + (error.message || '未知错误'));
      }
    },

    async saveCategoryAnalysisToBoard(draftData) {
      try {
        // 获取文章标题，如果没有标题则使用默认标题
        const title = this.title || '分类元素分析';
        
        // 获取paperId作为source_id
        const paperId = this.$route.query.paperId;
        
        // 直接调用添加白板的API
        const response = await request('/api/Draft/addDraft', {
          title: title,
          content: JSON.stringify(draftData), // 分类分析结果作为content
          type: 3, // 设置为分类分析白板类型
          source_id: paperId || '',
          source: 3
        });
        
        // 保存白板ID供跳转使用
        this.savedDraftId = response;
        
      } catch (error) {
        console.error('保存白板失败:', error);
        throw new Error('保存白板失败：' + (error.message || '未知错误'));
      }
    },

    async performEntityAnalysis() {
      try {
        // 执行分析
        const analysisResult = await analyzeEntitiesAndRelationships(this.content);
        
        // 调用保存白板的接口
        await this.saveEntityAnalysisToBoard(analysisResult);
        
        this.$message.success('实体关系分析完成并已保存，正在跳转到白板页面...');
        
        // 完成实体关系分析步骤
        this.$store.dispatch('processFlow/nextStep')
        
        // 延迟跳转到白板页面
        setTimeout(() => {
          // 跳转到草稿/白板页面，带上已保存的白板ID
          this.$router.push({
            name: 'draft',
            query: {
              id: this.savedDraftId || '',
              type: 'entity-analysis',
              source: 'note'
            }
          });
        }, 1000);
        
      } catch (error) {
        console.error('实体关系分析失败:', error);
        this.$message.error('实体关系分析失败：' + (error.message || '未知错误'));
        // 分析失败时暂停流程
        this.$store.dispatch('processFlow/pauseFlow')
      }
    },

    async saveEntityAnalysisToBoard(analysisResult) {
      try {
        // 获取文章标题，如果没有标题则使用默认标题
        const title = this.title || '实体关系分析';
        
        // 获取paperId作为source_id
        const paperId = this.$route.query.paperId;
        
        // 直接调用添加白板的API
        const response = await request('/api/Draft/addDraft', {
          title: title,
          content: JSON.stringify(analysisResult), // coze的完整响应作为content
          type: 2, // 设置为特殊白板
          source_id: paperId || '',
          source: 3
        });
        
        // 保存白板ID供跳转使用
        this.savedDraftId = response;
        
        // 保存所有实体为词条
        await this.saveEntitiesToKeywords(analysisResult);
        
      } catch (error) {
        console.error('保存白板失败:', error);
        throw new Error('保存白板失败：' + (error.message || '未知错误'));
      }
    },

    async saveEntitiesToKeywords(analysisResult) {
      try {
        // 提取所有实体
        const entities = analysisResult.entities || [];
        
        if (!entities.length) {
          return;
        }
        
        // 直接使用 analysisResult 作为 draft_info，和保存白板时使用相同的数据
        const draftInfo = JSON.stringify(analysisResult);
        
        const result = await request('/api/Keywords/addDraftKeywordsInfo', {
          draft_info: draftInfo
        });
        
        // 显示保存成功的提示
        if (result && result.result && result.result.length > 0) {
          const savedCount = result.result.length;
          this.$message.success(`成功保存 ${savedCount} 个实体词条`);
        }
        
      } catch (error) {
        console.error('保存实体词条失败:', error);
        // 不抛出错误，避免影响主流程
        // 只记录日志，让用户能继续跳转到白板页面
      }
    },

    renderLatexFormulas() {
      // 禁用自动LaTeX渲染，使用悬浮预览方案
      return
      
      // 渲染编辑器中的LaTeX公式
      this.$nextTick(() => {
        const editorContent = document.querySelector('.el-tiptap-editor__content')
        if (editorContent) {
          // 查找所有包含$符号的文本节点并渲染LaTeX
          const textNodes = this.getTextNodes(editorContent)
          textNodes.forEach(node => {
            const text = node.textContent
            if (text.includes('$')) {
              const renderedHtml = renderLatexInHtml(text)
              if (renderedHtml !== text) {
                const wrapper = document.createElement('div')
                wrapper.innerHTML = renderedHtml
                
                // 替换文本节点
                const parent = node.parentNode
                while (wrapper.firstChild) {
                  parent.insertBefore(wrapper.firstChild, node)
                }
                parent.removeChild(node)
              }
            }
          })
        }
      })
    },

    getTextNodes(element) {
      const textNodes = []
      const walker = document.createTreeWalker(
        element,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode: function(node) {
            // 跳过已经渲染的LaTeX公式
            if (node.parentNode && node.parentNode.classList && 
                node.parentNode.classList.contains('latex-formula')) {
              return NodeFilter.FILTER_REJECT
            }
            return NodeFilter.FILTER_ACCEPT
          }
        },
        false
      )
      
      let node
      while (node = walker.nextNode()) {
        textNodes.push(node)
      }
      
      return textNodes
    },
    
    setupLatexPreview() {
      // LaTeX预览现在改为手动触发模式，不再自动监听选中事件
      // 只有在用户点击LaTeX按钮时才会触发预览功能
      console.log('LaTeX preview set to manual mode - triggered only by button click')
    },
    
    
    containsLatexFormula(text) {
      // 检测是否包含LaTeX公式（$...$或$$...$$）
      return /\$.*?\$/.test(text)
    },
    
    handleSelectionChange() {
      // 延迟执行，避免与编辑器的内部处理冲突
      setTimeout(() => {
        try {
      const selection = window.getSelection()
      
          if (!selection || selection.rangeCount === 0) {
            this.$refs.latexPreview && this.$refs.latexPreview.hide()
        return
      }
      
      const selectedText = selection.toString().trim()
          
          // 只有在真正选中文本时才显示预览（不处理光标位置）
          if (selectedText === '') {
            this.$refs.latexPreview && this.$refs.latexPreview.hide()
            return
          }
      
          // 检测是否选中了LaTeX公式
          let latexMatch = this.detectLatexFormula(selectedText)
          const range = selection.getRangeAt(0)
          
          // 如果直接文本检测失败，尝试从选中的元素中获取LaTeX公式
          if (!latexMatch) {
            latexMatch = this.detectLatexFromSelection(range)
          }
      
      if (latexMatch) {
        const rect = range.getBoundingClientRect()
        
            // 确保有有效的边界框
            if (rect.width === 0 && rect.height === 0) {
              return
            }
            
            // 紧邻选中文本显示预览框
            const x = rect.right + 5 // 选中区域右侧5px
            const y = rect.top        // 与选中区域顶部对齐
        
        // 确保预览框不超出视窗边界
        const viewportWidth = window.innerWidth
        const viewportHeight = window.innerHeight
            const previewWidth = 500 // 预览框宽度（匹配插入预览）
            const previewHeight = 80  // 预览框高度
        
        let finalX = x
        let finalY = y
        
            // 优先显示在右侧，如果右侧空间不够则显示在左侧
            if (x + previewWidth > viewportWidth - 20) {
              finalX = rect.left - previewWidth - 5
            }
            
            // 如果左侧也不够空间，则显示在下方
            if (finalX < 20) {
              finalX = rect.left
              finalY = rect.bottom + 5
            }
            
            // 如果下方空间不够，则显示在上方
            if (finalY + previewHeight > viewportHeight - 20) {
              finalY = rect.top - previewHeight - 5
            }
            
            // 最终确保不超出边界
        if (finalX < 10) {
          finalX = 10
        }
        if (finalY < 10) {
          finalY = 10
        }
            if (finalX + previewWidth > viewportWidth - 10) {
              finalX = viewportWidth - previewWidth - 10
            }
            if (finalY + previewHeight > viewportHeight - 10) {
              finalY = viewportHeight - previewHeight - 10
            }
            
            this.$refs.latexPreview && this.$refs.latexPreview.show(latexMatch.formula, finalX, finalY, latexMatch.displayMode)
      } else {
            this.$refs.latexPreview && this.$refs.latexPreview.hide()
          }
        } catch (error) {
          console.error('处理选择变化时出错:', error)
        }
      }, 10)
    },
    
    
    detectLatexFormula(text) {
      // 检测块级公式 $$...$$
      const blockMatch = text.match(/^\$\$(.*?)\$\$$/s)
      if (blockMatch) {
        return {
          formula: blockMatch[1].trim(),
          displayMode: true
        }
      }
      
      // 检测内联公式 $...$
      const inlineMatch = text.match(/^\$(.*?)\$$/s)
      if (inlineMatch) {
        return {
          formula: inlineMatch[1].trim(),
          displayMode: false
        }
      }
      
      return null
    },
    
    detectLatexFromSelection(range) {
      try {
        // 检查选中的范围是否包含带有LaTeX标记的span元素
        const fragment = range.cloneContents()
        const spans = fragment.querySelectorAll('span[data-latex-formula]')
        
        if (spans.length > 0) {
          // 如果找到LaTeX span，从data属性中获取公式
          const latexFormula = spans[0].getAttribute('data-latex-formula')
          return this.detectLatexFormula(latexFormula)
        }
        
        // 如果选中范围内没有LaTeX span，检查是否选中了LaTeX span本身
        const container = range.commonAncestorContainer
        if (container.nodeType === Node.ELEMENT_NODE) {
          const latexSpan = container.querySelector('span[data-latex-formula]')
          if (latexSpan) {
            const latexFormula = latexSpan.getAttribute('data-latex-formula')
            return this.detectLatexFormula(latexFormula)
          }
        }
        
        // 检查父级元素是否是LaTeX span
        let element = container
        while (element && element.nodeType !== Node.DOCUMENT_NODE) {
          if (element.nodeType === Node.ELEMENT_NODE && 
              element.tagName === 'SPAN' && 
              element.hasAttribute('data-latex-formula')) {
            const latexFormula = element.getAttribute('data-latex-formula')
            return this.detectLatexFormula(latexFormula)
          }
          element = element.parentNode
        }
        
        return null
      } catch (error) {
        console.error('从选中元素检测LaTeX时出错:', error)
        return null
      }
    },
    
    
    
  },
  mounted () {
    this.$nextTick(() => {
      if(this.$refs.editor) {
        this.editorInstance = this.$refs.editor.editor
        // LaTeX预览现在是手动模式，可以安全启用
        this.setupLatexPreview()
      }
    })
  },
  
  updated() {
    // 当组件更新时（包括editorKey变化导致的重新创建），重新获取编辑器实例
    this.$nextTick(() => {
      if(this.$refs.editor && this.$refs.editor.editor) {
        this.editorInstance = this.$refs.editor.editor
        // LaTeX预览现在是手动模式，可以安全启用
        this.setupLatexPreview()
      }
    })
  },
  
  beforeDestroy() {
    // LaTeX现在是手动模式，不需要清理自动事件监听器
  }
}
</script>

<style lang="scss" scoped>
.right-toolbar {
  position: absolute;
  top: 9px;
  right: 15px;
  display: flex;
  align-items: center;

  > * {
    margin-left: 10px;
  }
  
  i {
    font-size: 20px;
    cursor: pointer;
  }
  
  img {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
}

.el-tiptap-editor {
  padding: 0 2px 0 0;
  height: 93vh;
  width: 90vw;
  position: relative;
  overflow: visible;
}

:deep(.download-popover){
  background: #030303;
  color: #fff;
  padding: 10px;
}

/* 使用 ::v-deep 选择器 */
.el-tiptap-editor ::v-deep .el-tiptap-editor__menu-bar {
  padding: 0 0 0 5px;
  justify-content: flex-start;
}

.el-tiptap-editor ::v-deep .el-tiptap-editor__command-button {
  height: 35px;
  width: 35px;
}

.el-tiptap-editor ::v-deep .el-tiptap-editor__content {
  padding: 10px 20px;
}

.el-tiptap-editor ::v-deep .el-tiptap-editor__footer {
  padding: 5px 10px;
}

.el-tiptap-editor ::v-deep .border-bottom-radius {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.el-tiptap-editor ::v-deep .border-top-radius {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

/* 恢复bubble menu的原始样式 */
.el-tiptap-editor ::v-deep .el-tiptap-editor__menu-bubble {
  z-index: 9999 !important;
}

/* 搜索高亮样式 - 使选中的文本更明显 */
.el-tiptap-editor ::v-deep .ProseMirror ::selection {
  background-color: #ff5722 !important;
  color: white !important;
}

.el-tiptap-editor ::v-deep .ProseMirror ::-moz-selection {
  background-color: #ff5722 !important;
  color: white !important;
}

.el-tiptap-editor ::v-deep .ProseMirror .ProseMirror-selectednode {
  background-color: #ffeb3b !important;
  outline: 2px solid #ff5722 !important;
}

.title-box :deep(.el-dialog) {
  width: 500px;
  height: 200px;
}

.title-box :deep(.el-dialog__body) {
  padding: 20px;
  display: flex;
  flex-direction: column;
}

.dialog-content {
  max-height: 400px;
  overflow: auto;
}

.add-content {
  height: 50px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.el-select {
  width: 100px;
  margin-left: 10px;
}

.el-icon-delete {
  cursor: pointer;
  margin-left: 10px;
  color: red;
}

// 分享弹窗样式
.share-dialog {
  :deep(.el-dialog) {
    border-radius: 12px;
  }
  
  :deep(.el-dialog__header) {
    padding: 20px 20px 10px;
    border-bottom: 1px solid #f0f0f0;
  }
  
  :deep(.el-dialog__body) {
    padding: 0;
  }
  
  :deep(.el-dialog__footer) {
    padding: 15px 20px;
    border-top: 1px solid #f0f0f0;
    text-align: right;
  }
}

.share-content {
  padding: 20px;
}

.share-tip {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  padding: 12px;
  background-color: #f0f9ff;
  border: 1px solid #bfdbfe;
  border-radius: 8px;
  
  i {
    color: #3b82f6;
    margin-right: 8px;
    font-size: 16px;
  }
  
  span {
    color: #1e40af;
    font-size: 14px;
  }
}

.no-friends {
  text-align: center;
  padding: 40px 20px;
  color: #909399;
  
  i {
    font-size: 48px;
    color: #c0c4cc;
    display: block;
    margin-bottom: 16px;
  }
  
  p {
    margin: 0;
    font-size: 16px;
    
    &.tip {
      font-size: 14px;
      color: #c0c4cc;
      margin-top: 8px;
    }
  }
}

.friend-list {
  max-height: 400px;
  overflow-y: auto;

  .item-friend {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 12px;
    margin-bottom: 8px;
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    transition: all 0.3s ease;
    cursor: pointer;

    &:hover {
      background-color: #f5f7fa;
      border-color: #c0c4cc;
    }

    &:last-child {
      margin-bottom: 0;
    }

    .left {
      margin-right: 12px;
      flex-shrink: 0;
    }

    .right {
      display: flex;
      align-items: center;
      flex: 1;
      min-width: 0; // 确保文字可以正确截断

      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 12px;
        object-fit: cover;
        border: 2px solid #e4e7ed;
        flex-shrink: 0;
      }

      .nick {
        font-size: 14px;
        color: #303133;
        font-weight: 500;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        flex: 1;
      }
    }
  }
}

// 复制链接弹窗样式
:deep(.copy-link-dialog) {
  .el-message-box__content {
    word-break: break-all;
    user-select: all;
    padding: 20px;
    background-color: #f5f7fa;
    border-radius: 8px;
    border: 1px solid #e4e7ed;
    font-family: 'Courier New', monospace;
    font-size: 14px;
    color: #606266;
  }
  
  .el-message-box__btns {
    padding-top: 20px;
  }
}

// LaTeX 公式样式
.el-tiptap-editor ::v-deep .latex-formula {
  display: inline-block !important;
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 4px;
  transition: all 0.2s ease;
  border: 1px solid rgba(102, 126, 234, 0.2);
  background-color: rgba(102, 126, 234, 0.08) !important;
  margin: 0 2px;
  position: relative;
  visibility: visible !important;
  opacity: 1 !important;
  min-height: 20px !important;
  min-width: 20px !important;

  &:hover {
    background-color: rgba(102, 126, 234, 0.15);
    border-color: rgba(102, 126, 234, 0.4);
    transform: scale(1.02);
    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.2);
  }

  &.latex-block {
    display: block;
    text-align: center;
    margin: 15px auto;
    padding: 20px;
    background-color: rgba(102, 126, 234, 0.1);
    border-radius: 8px;
    max-width: 100%;
    
    .katex-display {
      margin: 0 !important;
    }
  }

  &.latex-inline {
    display: inline-block;
    vertical-align: middle;
    line-height: 1;
  }

  // 确保KaTeX样式正确应用
  .katex {
    font-size: 1.1em !important;
    color: #2c3e50 !important;
    display: inline-block !important;
    visibility: visible !important;
    opacity: 1 !important;
    
    .katex-html {
      color: inherit !important;
      display: inline-block !important;
      visibility: visible !important;
      opacity: 1 !important;
    }
    
    .katex-mathml {
      display: none !important;
    }
  }

  .katex-display {
    margin: 0 !important;
    text-align: center !important;
  }

  // 确保LaTeX公式不可编辑
  &[contenteditable="false"] {
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    outline: none;
  }

  // 修复KaTeX字体问题
  .katex .mathnormal {
    font-family: KaTeX_Math, "Times New Roman", serif !important;
  }

  .katex .mathit {
    font-family: KaTeX_Math, "Times New Roman", serif !important;
  }
}

// 确保编辑器内的KaTeX样式不被覆盖
.el-tiptap-editor ::v-deep .katex {
  font: normal 1.21em KaTeX_Main, "Times New Roman", serif !important;
}

.el-tiptap-editor ::v-deep .katex * {
  border-color: currentColor !important;
}

// 插入的LaTeX公式样式
.el-tiptap-editor ::v-deep {
  // 为插入的LaTeX公式提供统一样式
  span[data-latex-formula] {
    text-decoration: underline !important;
    text-decoration-color: rgba(102, 126, 234, 0.6) !important;
    background-color: rgba(102, 126, 234, 0.08) !important;
    border-radius: 4px !important;
    padding: 2px 4px !important;
    font-family: 'Consolas', 'Monaco', 'Courier New', monospace !important;
    font-size: 0.95em !important;
    border: 1px solid rgba(102, 126, 234, 0.2) !important;
    margin: 0 2px !important;
    color: #5a67d8 !important;
    display: inline !important;
    cursor: text !important;
    user-select: text !important;
  }
  
  // 简化的LaTeX文本高亮 - 仅用于辅助识别，不干扰选择
  .latex-highlight {
    background: linear-gradient(transparent 60%, rgba(102, 126, 234, 0.2) 60%, rgba(102, 126, 234, 0.2) 90%, transparent 90%) !important;
    border-radius: 2px !important;
  }
}

// 全局KaTeX样式修复 - 确保数学公式正确显示
.katex {
  font: normal 1.21em KaTeX_Main, "Times New Roman", serif !important;
  line-height: 1.2 !important;
  text-indent: 0 !important;
  text-rendering: auto !important;
  border-collapse: separate !important;
  
  .katex-html {
    display: inline-block !important;
    
    .base {
      position: relative !important;
      display: inline-block !important;
    }
    
    .strut {
      display: inline-block !important;
    }
    
    .mord {
      margin-right: 0 !important;
      
      &.mopen, &.mclose {
        margin-right: 0 !important;
      }
    }
    
    .mfrac {
      text-align: center !important;
      
      .vlist-t {
        display: inline-table !important;
        table-layout: fixed !important;
        border-collapse: separate !important;
      }
      
      .vlist-r {
        display: table-row-group !important;
      }
      
      .vlist {
        display: table-row !important;
        
        > span {
          display: table-cell !important;
          vertical-align: baseline !important;
          text-align: center !important;
        }
      }
      
      .frac-line {
        border-bottom-width: 0.04em !important;
        border-bottom-style: solid !important;
        border-bottom-color: currentColor !important;
        margin: 0 !important;
        display: block !important;
      }
    }
    
    .nulldelimiter {
      display: inline-block !important;
      width: 0 !important;
    }
    
    .sizing {
      display: inline !important;
    }
    
    .mathnormal {
      font-family: KaTeX_Math, "Times New Roman", serif !important;
    }
  }
  
  .katex-mathml {
    display: none !important;
  }
}
</style>
